import { Eroor404Component } from './eroor404.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
const routes: Routes = [

  {
    path: '',
    component: Eroor404Component,

  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports:[RouterModule]
})
export class Error404RoutingModule {}
